import {
  FETCH_TOTAL_ANALYTICS,
  FETCH_TOTAL_ANALYTICS_ERROR,
  CLEAR_TOTAL_ANALYTICS,
  FETCH_DAY_BY_DAY_ANALYTICS,
  FETCH_DAY_BY_DAY_ANALYTICS_ERROR,
  CLEAR_DAY_BY_DAY_ANALYTICS,
  FETCH_TOP_LINKS,
  FETCH_TOP_LINKS_ERROR,
  CLEAR_TOP_LINKS,
  FETCH_TOP_LINK_DETAILS,
  FETCH_TOP_LINK_DETAILS_ERROR,
  CLEAR_TOP_LINK_DETAILS,
  FETCH_DEVICE_CATEGORIES,
  FETCH_DEVICE_CATEGORIES_ERROR,
  CLEAR_DEVICE_CATEGORIES,
  FETCH_MOBILE_DEVICES,
  FETCH_MOBILE_DEVICES_ERROR,
  CLEAR_MOBILE_DEVICES,
  FETCH_AUDIENCE_BY_COUNTRY,
  FETCH_AUDIENCE_BY_COUNTRY_ERROR,
  CLEAR_AUDIENCE_BY_COUNTRY,
  FETCH_AUDIENCE_BY_GLOBAL_MARKET,
  FETCH_AUDIENCE_BY_GLOBAL_MARKET_ERROR,
  CLEAR_AUDIENCE_BY_GLOBAL_MARKET,
  FETCH_AUDIENCE_BY_CITY,
  FETCH_AUDIENCE_BY_CITY_ERROR,
  CLEAR_AUDIENCE_BY_CITY,
  FETCH_REFERRERS,
  FETCH_REFERRERS_ERROR,
  CLEAR_REFERRERS,
  FETCH_TOP_LINKS_CSV,
  FETCH_TOP_LINKS_CSV_ERROR,
  CLEAR_FETCH_TOP_LINKS_CSV,
  FETCH_REFERRERS_CSV,
  FETCH_REFERRERS_CSV_ERROR,
  CLEAR_FETCH_REFERRERS_CSV,
} from 'redux/analytics/types';

const initialState = {
  analyticsTotal: null,
  analyticsTotalError: null,
  analyticsByDay: null,
  analyticsByDayError: null,
  topLinks: null,
  topLinksError: null,
  topLinkDetails: null,
  topLinkDetailsError: null,
  deviceCategories: null,
  deviceCategoriesError: null,
  mobileDevices: null,
  mobileDevicesError: null,
  audienceByCountry: null,
  audienceByCountryError: null,
  audienceByGlobalMarket: null,
  audienceByGlobalMarketError: null,
  audienceByCity: null,
  audienceByCityError: null,
  analyticsReferrers: null,
  analyticsReferrersError: null,
  topLinksCsv: null,
  topLinksCsvError: null,
  referrersCsv: null,
  referrersCsvError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TOTAL_ANALYTICS:
      return {
        ...state,
        analyticsTotal: action.payload.data,
        analyticsTotalError: null,
      };
    case FETCH_TOTAL_ANALYTICS_ERROR:
      return {
        ...state,
        analyticsTotal: null,
        analyticsTotalError: action.payload.data,
      };
    case CLEAR_TOTAL_ANALYTICS:
      return {
        ...state,
        analyticsTotal: null,
        analyticsTotalError: null,
      };
    case FETCH_DAY_BY_DAY_ANALYTICS:
      return {
        ...state,
        analyticsByDay: action.payload.data,
        analyticsByDayError: null,
      };
    case FETCH_DAY_BY_DAY_ANALYTICS_ERROR:
      return {
        ...state,
        analyticsByDay: null,
        analyticsByDayError: action.payload.data,
      };
    case CLEAR_DAY_BY_DAY_ANALYTICS:
      return {
        ...state,
        analyticsByDay: null,
        analyticsByDayError: null,
      };
    case FETCH_TOP_LINKS:
      return {
        ...state,
        topLinks: action.payload.data,
        topLinksError: null,
      };
    case FETCH_TOP_LINKS_ERROR:
      return {
        ...state,
        topLinks: null,
        topLinksError: action.payload.data,
      };
    case CLEAR_TOP_LINKS:
      return {
        ...state,
        topLinks: null,
        topLinksError: null,
      };
    case FETCH_TOP_LINK_DETAILS:
      return {
        ...state,
        topLinkDetails: action.payload.data,
        topLinkDetailsError: null,
      };
    case FETCH_TOP_LINK_DETAILS_ERROR:
      return {
        ...state,
        topLinkDetails: null,
        topLinkDetailsError: action.payload.data,
      };
    case CLEAR_TOP_LINK_DETAILS:
      return {
        ...state,
        topLinkDetails: null,
        topLinkDetailsError: null,
      };
    case FETCH_DEVICE_CATEGORIES:
      return {
        ...state,
        deviceCategories: action.payload.data,
        deviceCategoriesError: null,
      };
    case FETCH_DEVICE_CATEGORIES_ERROR:
      return {
        ...state,
        deviceCategories: null,
        deviceCategoriesError: action.payload.data,
      };
    case CLEAR_DEVICE_CATEGORIES:
      return {
        ...state,
        deviceCategories: null,
        deviceCategoriesError: null,
      };
    case FETCH_MOBILE_DEVICES:
      return {
        ...state,
        mobileDevices: action.payload.data,
        mobileDevicesError: null,
      };
    case FETCH_MOBILE_DEVICES_ERROR:
      return {
        ...state,
        mobileDevices: null,
        mobileDevicesError: action.payload.data,
      };
    case CLEAR_MOBILE_DEVICES:
      return {
        ...state,
        mobileDevices: null,
        mobileDevicesError: null,
      };
    case FETCH_AUDIENCE_BY_COUNTRY:
      return {
        ...state,
        audienceByCountry: action.payload.data,
        audienceByCountryError: null,
      };
    case FETCH_AUDIENCE_BY_COUNTRY_ERROR:
      return {
        ...state,
        audienceByCountry: null,
        audienceByCountryError: action.payload.data,
      };
    case CLEAR_AUDIENCE_BY_COUNTRY:
      return {
        ...state,
        audienceByCountry: null,
        audienceByCountryError: null,
      };
    case FETCH_AUDIENCE_BY_GLOBAL_MARKET:
      return {
        ...state,
        audienceByGlobalMarket: action.payload.data,
        audienceByGlobalMarketError: null,
      };
    case FETCH_AUDIENCE_BY_GLOBAL_MARKET_ERROR:
      return {
        ...state,
        audienceByGlobalMarket: null,
        audienceByGlobalMarketError: action.payload.data,
      };
    case CLEAR_AUDIENCE_BY_GLOBAL_MARKET:
      return {
        ...state,
        audienceByGlobalMarket: null,
        audienceByGlobalMarketError: null,
      };
    case FETCH_AUDIENCE_BY_CITY:
      return {
        ...state,
        audienceByCity: action.payload.data,
        audienceByCityError: null,
      };
    case FETCH_AUDIENCE_BY_CITY_ERROR:
      return {
        ...state,
        audienceByCity: null,
        audienceByCityError: action.payload.data,
      };
    case CLEAR_AUDIENCE_BY_CITY:
      return {
        ...state,
        audienceByCity: null,
        audienceByCityError: null,
      };
    case FETCH_REFERRERS:
      return {
        ...state,
        analyticsReferrers: action.payload.data,
        analyticsReferrersError: null,
      };
    case FETCH_REFERRERS_ERROR:
      return {
        ...state,
        analyticsReferrers: null,
        analyticsReferrersError: action.payload.data,
      };
    case CLEAR_REFERRERS:
      return {
        ...state,
        analyticsReferrers: null,
        analyticsReferrersError: null,
      };
    case FETCH_TOP_LINKS_CSV:
      return {
        ...state,
        topLinksCsv: action.payload.data,
        topLinksCsvError: null,
      };
    case FETCH_TOP_LINKS_CSV_ERROR:
      return {
        ...state,
        topLinksCsv: null,
        topLinksCsvError: action.payload.data,
      };
    case CLEAR_FETCH_TOP_LINKS_CSV:
      return {
        ...state,
        topLinksCsv: null,
        topLinksCsvError: null,
      };
    case FETCH_REFERRERS_CSV:
      return {
        ...state,
        referrersCsv: action.payload.data,
        referrersCsvError: null,
      };
    case FETCH_REFERRERS_CSV_ERROR:
      return {
        ...state,
        referrersCsv: null,
        referrersCsvError: action.payload.data,
      };
    case CLEAR_FETCH_REFERRERS_CSV:
      return {
        ...state,
        referrersCsv: null,
        referrersCsvError: null,
      };
    default:
      return state;
  }
};
